import thumbnail from "../../../assets/images/projects/hagah/thumbnail.png";
import { ProjectDataProps } from "../props";

export default {
  title: "Daily Scripture Meditation",
  description:
    "A quiet daily practice for reading, reciting, remembering, and reflecting on Scripture.",
  image: thumbnail,
  path: "/hagah",
  thumbnailBackground:
    "linear-gradient(160deg, #0b0d0d 0%, #203b50 48%, #8f927c 100%)",
  thumbnailFit: "cover",
  thumbnailPosition: "center",
  thumbnailScale: 1,
} as ProjectDataProps;
